import React, { forwardRef } from 'react';

interface PlusSquareProps {
  classes?: string;
  style?: React.CSSProperties;
  forwardRef?: React.RefObject<HTMLElement>;
}

export const PlusSquare = forwardRef<HTMLElement, PlusSquareProps>(({ classes, style = {}, forwardRef: _ }, ref) => {
  return (
    <i ref={ref} className={`fa-solid fa-square-plus ${classes}`} style={style}></i>
  );
});

PlusSquare.displayName = 'PlusSquare';
